import { css } from '@emotion/react';

export const HideScroll = css`
  &::-webkit-scrollbar {
    display: none;
  }
`;
